import React from 'react';
import {
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';
// Radial separators
import RadialSeparators from "./RadialSeparators";

const DashedCircleProgressBar = ({ value, text, color, textColor }) => {
  // Calculate the stroke dash offset based on the progress value
  const radius = 45; // Radius of the circle
  const circumference = 2 * Math.PI * radius;

  return (

    <div style={{width: '50px', height: '50px', margin: '0 auto',}}>
      <CircularProgressbarWithChildren
        value={value}
        text={text}
        strokeWidth={10}
        styles={buildStyles({
          strokeLinecap: "butt",
          textColor: textColor, // Set the text color
          textSize: '30px', // Optional: adjust text size
          pathColor: color,
         // trailColor: "gold"
        })}
      >
        <RadialSeparators
          count={10}
          style={{
            background: "#fff",
            width: "2px",
            // This needs to be equal to props.strokeWidth
            height: `${10}%`
          }}
        />
      </CircularProgressbarWithChildren>

      
    </div>
  );
};



export default DashedCircleProgressBar;